import http from "../../http";

const transfer = {
    // 查询转账订单分页
    selectCompanyByPage(r) {
        return http.get("/gateway/api/sycompany/pc/CompanyTransferPC/selectCompanyByPage", r)
    },
    // 查询转账订单详情
    selectById(r) {
        return http.spin.get("/gateway/api/sycompany/pc/CompanyTransferPC/selectById", r)
    },
    // 审核
    checkTransfer(r) {
        return http.spin.payload("/gateway/api/sycompany/pc/CompanyTransferPC/checkTransfer", r)
    },
}
export default transfer
